import {
	updateShippingMethods
} from './_updateShippingMethods';

export const qcProfileCardInfoChange = () => {
	
	$(".card-info").on("change",function(){
		if(!$("#payment-info-update-card-type").val() == ""){
			$(".card-buttons").show();
			
		}else{
		    document.quickCheckoutProfileForm.qc_pay_account.disabled = false;
	  		document.quickCheckoutProfileForm.qc_pay_expire_month.selectedIndex = 0;
			document.quickCheckoutProfileForm.qc_pay_expire_month.disabled = false;
			document.quickCheckoutProfileForm.qc_pay_expire_year.selectedIndex = 0;
			document.quickCheckoutProfileForm.qc_pay_expire_year.disabled = false;
			if(document.quickCheckoutProfileForm.qc_pay_cc_cvc){
				document.quickCheckoutProfileForm.qc_pay_cc_cvc.disabled = false;
			}
			$(".card-buttons").hide();
		}
	})

	$('#payment-info-add-card-number').on('input',function(){
		if($('.card-info').val() === '11052,VISA,VISA'){
			$('.card-type.private-label').hide();
			$('.card-type.dillards-mastercard').hide();
		  $('.card-type.visa').show();
			$('.cvv-text-amex').hide();
			$('.card-type.front').hide();
		  $('.card-type.back').show();
		  $('.cvv-text').show();
		}else{
		  $('.card-type.visa').hide();
		}

		if($('.card-info').val() === '11055,Discover,Discover'){
			$('.card-type.private-label').hide();
			$('.card-type.dillards-mastercard').hide();
		  $('.card-type.discover').show();
			$('.cvv-text-amex').hide();
			$('.card-type.front').hide();
		  $('.card-type.back').show();
		  $('.cvv-text').show();
		}else{
		  $('.card-type.discover').hide();
		}

		if($('.card-info').val() === '11053,Master Card,Master Card'){
			$('.card-type.private-label').hide();
			$('.card-type.dillards-mastercard').hide();
		  $('.card-type.mastercard').show();
			$('.cvv-text-amex').hide();
			$('.card-type.front').hide();
		  $('.card-type.back').show();
		  $('.cvv-text').show();
		}else{
		  $('.card-type.mastercard').hide();
		}

		if($('.card-info').val() === '11056,Dillards Charge,Dillards Charge'){
			$('.card-type.private-label').hide();
			$('.card-type.dillards-mastercard').hide();
		  $('.dillards-card.basic').show();
			$('.cvv-text-amex').hide();
			$('.card-type.front').hide();
		  $('.card-type.back').show();
		  $('.cvv-text').show();
		}else{
		  $('.dillards-card.basic').hide();    
		}

		if($('.card-info').val() === '11057,Dillards AMEX Charge,Dillards AMEX Charge'){
			$('.card-type.private-label').hide();
			$('.card-type.dillards-mastercard').hide();
		  $('.dillards-card-elite').show();
		  $('.card-type.back').hide();
		  $('.cvv-text').hide();
		  $('.cvv-text-amex').show();
		  $('.card-type.front').show();
		}else{
		  $('.dillards-card-elite').hide();
		}

		if($('.card-info').val() === '11054,AMEX,AMEX'){
			$('.card-type.private-label').hide();
			$('.card-type.dillards-mastercard').hide();
		  $('.card-type.amex').show();
		  $('.card-type.back').hide();
		  $('.cvv-text').hide();
		  $('.cvv-text-amex').show();
		  $('.card-type.front').show();
		}else{
		  $('.card-type.amex').hide();
		}

		if($('.card-info').val() === '11064,Dillards Private Label,Dillards Private Label'){
			$('.card-type.private-label').show();
			$('.card-type.dillards-mastercard').hide();
			$('.card-type.amex').hide();
			$('.card-type.back').show();
			$('.cvv-text').show();
			$('.cvv-text-amex').hide();
			$('.card-type.front').hide();
		}else{
			$('.card-type.private-label').hide();
		}

		if($('.card-info').val() === '11063,Dillards Mastercard,Dillards Mastercard'){
			$('.card-type.dillards-mastercard').show();
			$('.card-type.private-label').hide();
			$('.card-type.amex').hide();
			$('.card-type.back').show();
			$('.cvv-text').show();
			$('.cvv-text-amex').hide();
			$('.card-type.front').hide();
		}else{
			$('.card-type.dillards-mastercard').hide();
		}

		if($('.card-info').val() === ""){
		  $('.card-type.back').hide();
		  $('.card-type.front').hide();
		  $('.cvv-text').hide();
		  $('.cvv-text-amex').hide();
		}
		
	  });
	

	//this will update shipping methods when the customer clicks off of address1
	$("#quick-checkout-shipping-address-1").focus(function() {
	}).blur(function() {
	    updateShippingMethods(document.quickCheckoutProfileForm);
	});

	//this will update shipping methods when the customer clicks off of address2
	$("#quick-checkout-shipping-address-2").focus(function() {
	}).blur(function() {
	    updateShippingMethods(document.quickCheckoutProfileForm);
	});

	updateShippingMethods(document.quickCheckoutProfileForm);
};
